import { createContext, useContext, type ReactNode } from "react";

const LandingSignupContext = createContext<(() => void) | null>(null);

export function LandingSignupProvider({
  openSignup,
  children,
}: {
  openSignup: () => void;
  children: ReactNode;
}) {
  return <LandingSignupContext.Provider value={openSignup}>{children}</LandingSignupContext.Provider>;
}

export function useLandingSignup() {
  const open = useContext(LandingSignupContext);
  if (!open) {
    throw new Error("useLandingSignup must be used within LandingSignupProvider");
  }
  return open;
}
